export default "__VITE_ASSET__BGVG3DP7__"